module.exports = __webpack_public_path__ + "img/gratitude-journal_B095L4RD2R.3a7f754e.jpg";